import type {AuditActions, AuditData} from 'src/action-creators/audit';
import type {AttributeMetaData} from 'src/types/writeback';
import type {EntityType} from 'src/types/ats-entities';

import {
  RECEIVE_AUDIT,
  RECEIVE_WRITEBACK_ATTRIBUTES,
} from 'src/action-creators/audit';


export type AuditFields = Partial<Record<EntityType, AttributeMetaData[]>>;

export type AuditState = {
  all: AuditData;
  fields: AuditFields;
};

const initialState = {
  all: {},
  fields: {},
} as const;

export default (
  state: AuditState | null | undefined = initialState,
  action: AuditActions,
): AuditState => {
  switch (action.type) {
    case RECEIVE_AUDIT:
      // @ts-expect-error - TS2322 - Type '{ all: { page?: number; records_per_page?: number; total_pages?: number; total_records?: number; records?: AuditEntry[]; }; fields?: Partial<Record<EntityType, AttributeMetaData[]>> | undefined; }' is not assignable to type 'AuditState'.
      return {
        ...state,
        all: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.all,
          [action.payload.pageNumber]: action.payload.data,
        },
      };
    case RECEIVE_WRITEBACK_ATTRIBUTES:
      // @ts-expect-error - TS2322 - Type '{ fields: Partial<Record<EntityType, AttributeMetaData[]>>; all?: AuditData | undefined; }' is not assignable to type 'AuditState'.
      return {
        ...state,
        fields: action.payload,
      };
    default:
      // @ts-expect-error - TS2322 - Type 'AuditState | null' is not assignable to type 'AuditState'.
      return state;
  }
};
